<card-wrapper>
  <div class="content">
    <svg-icon-sprite
      src="./assets/img/icons/sprite.svg#hint"
      class="icon">
    </svg-icon-sprite>
    <h2 class="title" translate="profile-identity.us.rejected.title"></h2>
    <p class="subtitle" [innerHTML]="'profile-identity.us.rejected.description' | translate"></p>
    <btn
      buttonText="profile-identity.us.rejected.go-back"
      routerLink="../auto">
    </btn>
  </div>
</card-wrapper>